import React from 'react';
import { UploadCloud, X } from 'lucide-react';
import Input from '../../components/ui/Input';

export function SubjectDualForm({
  project = {},
  onChangeProject,
  onUploadAsset,
  onRemoveAsset
}) {
  const subjectA = project.subjectA || {};
  const subjectB = project.subjectB || {};

  const handleNameAChange = (e) => {
    onChangeProject({
      subjectA: { ...subjectA, name: e.target.value }
    });
  };

  const handleNameBChange = (e) => {
    onChangeProject({
      subjectB: { ...subjectB, name: e.target.value }
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
      {/* Top Dual Input Fields */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        <Input
          label="Chủ đề / sản phẩm A"
          value={subjectA.name || ''}
          onChange={handleNameAChange}
          placeholder="Ví dụ: Serum phục hồi da nhạy cảm"
          required
        />

        <Input
          label="Chủ đề / sản phẩm B"
          value={subjectB.name || ''}
          onChange={handleNameBChange}
          placeholder="Ví dụ: Serum cấp ẩm phục hồi nền da"
          required
        />
      </div>

      {/* Dual Cards for Visual Dropzones */}
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        {/* Card A (Orange/Coral) */}
        <div
          style={{
            background: '#FFFFFF',
            border: '1.5px solid rgba(234, 88, 12, 0.3)',
            borderRadius: 'var(--radius-md)',
            padding: '12px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            boxShadow: 'var(--shadow-sm)'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span
              style={{
                fontSize: '10px',
                fontWeight: 700,
                background: '#FFF7ED',
                color: '#EA580C',
                padding: '2px 8px',
                borderRadius: 'var(--radius-full)',
                border: '1px solid rgba(234, 88, 12, 0.2)'
              }}
            >
              Phương án A
            </span>
          </div>

          <div
            onClick={() => {
              const input = document.createElement('input');
              input.type = 'file';
              input.accept = 'image/*';
              input.onchange = (e) => e.target.files?.[0] && onUploadAsset(e.target.files[0], 'IMAGE_A');
              input.click();
            }}
            style={{
              width: '100%',
              height: '110px',
              background: '#FF8A50',
              backgroundImage: 'linear-gradient(135deg, #FFA07A 0%, #FF6B35 100%)',
              borderRadius: 'var(--radius-sm)',
              overflow: 'hidden',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'
            }}
          >
            {subjectA.imageUrl ? (
              <>
                <img
                  src={subjectA.imageUrl}
                  alt="Subject A"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemoveAsset('subjectA');
                  }}
                  style={{
                    position: 'absolute',
                    top: '6px',
                    right: '6px',
                    background: 'rgba(0,0,0,0.7)',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                >
                  <X size={12} />
                </button>
              </>
            ) : (
              <div style={{ textAlign: 'center', color: '#FFFFFF', padding: '6px' }}>
                <UploadCloud size={22} style={{ margin: '0 auto 4px' }} />
                <span style={{ fontSize: '12px', fontWeight: 700, display: 'block' }}>
                  Tải ảnh Phương án A
                </span>
                <span style={{ fontSize: '10px', opacity: 0.9 }}>
                  PNG, JPG hoặc WebP
                </span>
              </div>
            )}
          </div>

          <span style={{ fontSize: '11px', color: 'var(--text-muted)', lineHeight: 1.2 }}>
            {subjectA.name || 'Ảnh sản phẩm A'}
          </span>
        </div>

        {/* Card B (Blue) */}
        <div
          style={{
            background: '#FFFFFF',
            border: '1.5px solid rgba(37, 99, 235, 0.3)',
            borderRadius: 'var(--radius-md)',
            padding: '12px',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            boxShadow: 'var(--shadow-sm)'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span
              style={{
                fontSize: '10px',
                fontWeight: 700,
                background: '#EFF6FF',
                color: '#2563EB',
                padding: '2px 8px',
                borderRadius: 'var(--radius-full)',
                border: '1px solid rgba(37, 99, 235, 0.2)'
              }}
            >
              Phương án B
            </span>
          </div>

          <div
            onClick={() => {
              const input = document.createElement('input');
              input.type = 'file';
              input.accept = 'image/*';
              input.onchange = (e) => e.target.files?.[0] && onUploadAsset(e.target.files[0], 'IMAGE_B');
              input.click();
            }}
            style={{
              width: '100%',
              height: '110px',
              background: '#60A5FA',
              backgroundImage: 'linear-gradient(135deg, #93C5FD 0%, #3B82F6 100%)',
              borderRadius: 'var(--radius-sm)',
              overflow: 'hidden',
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer'
            }}
          >
            {subjectB.imageUrl ? (
              <>
                <img
                  src={subjectB.imageUrl}
                  alt="Subject B"
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onRemoveAsset('subjectB');
                  }}
                  style={{
                    position: 'absolute',
                    top: '6px',
                    right: '6px',
                    background: 'rgba(0,0,0,0.7)',
                    color: '#FFFFFF',
                    border: 'none',
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer'
                  }}
                >
                  <X size={12} />
                </button>
              </>
            ) : (
              <div style={{ textAlign: 'center', color: '#FFFFFF', padding: '6px' }}>
                <UploadCloud size={22} style={{ margin: '0 auto 4px' }} />
                <span style={{ fontSize: '12px', fontWeight: 700, display: 'block' }}>
                  Tải ảnh Phương án B
                </span>
                <span style={{ fontSize: '10px', opacity: 0.9 }}>
                  PNG, JPG hoặc WebP
                </span>
              </div>
            )}
          </div>

          <span style={{ fontSize: '11px', color: 'var(--text-muted)', lineHeight: 1.2 }}>
            {subjectB.name || 'Ảnh sản phẩm B'}
          </span>
        </div>
      </div>
    </div>
  );
}

export default SubjectDualForm;
